  document.addEventListener("DOMContentLoaded", function () {
  if (!window.Weglot) return;

  const img = document.getElementById("product-image");
  if (!img) return;

  const lang = Weglot.getCurrentLang();

  if (lang === "de" && img.dataset.srcDe) {
    img.src = img.dataset.srcDe;

    if (img.dataset.lightboxDe) {
      img.setAttribute("data-lightbox-src", img.dataset.lightboxDe);
    }
  } else {
    img.src = img.dataset.srcFr;

    if (img.dataset.lightboxFr) {
      img.setAttribute("data-lightbox-src", img.dataset.lightboxFr);
    }
  }
});



